import React from "react";
import { CalendarIcon } from "../../../../utils/icon.utils";
import Button from "../../../../ui/Button";

export default function VehicleCustomerRequirementDate({ data }) {
  return (
    <div className="position-absolute top-0 end-0 mt-3 me-3">
      <Button name={data} icon={CalendarIcon} />
    </div>
  );
}
